import { useEffect, useRef, useState } from 'react';

/** Mount children only after the placeholder enters the viewport (or immediately if unsupported). */
export default function LazyMount({ children, rootMargin = '200px', minHeight = 120, label = 'Загрузка…' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) return undefined;
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [visible, rootMargin]);

  if (visible) {
    return children;
  }

  return (
    <div
      ref={ref}
      style={{ minHeight }}
      className="flex items-center justify-center rounded-xl border border-dashed border-slate-200 text-xs text-slate-400 dark:border-slate-800"
    >
      {label}
    </div>
  );
}
